export default {
  en: {
    unique: {
      socialitegoogle: {
        register: 'Register with Google',
        login: 'Login with Google',
      }
    }
  },
  de: {
    unique: {
      socialitegoogle: {
        register: 'Mit Google registrieren',
        login: 'Mit Google anmelden',
      }
    }
  },
  es: {
    unique: {
      socialitegoogle: {
        register: 'Registrarse con Google',
        login: 'Iniciar sesión con Google',
      }
    }
  },
  uk: {
    unique: {
      socialitegoogle: {
        register: 'Зареєструватися через Google',
        login: 'Увійти через Google',
      }
    }
  }
}